export default "__VITE_ASSET__Dlohlsbm__"